import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TrayectoriaYValores from "./sections/TrayectoriaYValores";
import ExperienciasGastronomicas from "./sections/ExperienciasGastronomicas";
import SeleccionDeProyectos from "./sections/SeleccionDeProyectos";
import FinanciacionATuMedida from "./sections/FinanciacionATuMedida";
import ConectateConNosotros from "./sections/ConectateConNosotros";
import PieDePaginaApex from "@/reusable_sections/Footer";
import WhyChooseUs from "./sections/WhyChooseUs";
export default function HomePage() {
  return <div>
      <Header />
      
      <Hero />
      <div className="h-px bg-[#D9C28E] w-full" />
      <TrayectoriaYValores />
      <div className="h-px bg-[#D9C28E] w-full" />
      <ExperienciasGastronomicas />
      <div className="h-px bg-[#D9C28E] w-full" />
      <SeleccionDeProyectos />
      <div className="h-px bg-[#D9C28E] w-full" />
      <WhyChooseUs />
      <div className="h-px bg-[#D9C28E] w-full" />
      <ConectateConNosotros />
      <div className="h-px bg-[#D9C28E] w-full" />
      <PieDePaginaApex />
    </div>;
}